import { Component } from "@angular/core";

@Component({
  selector: "cla-redirect-prompt",
  templateUrl: "redirect-prompt.component.html",
  standalone: false,
})
export class RedirectPromptComponent {}
